export default __webpack_public_path__ + "static/media/github.510f10f3.svg";